<template>
  <div>
    <Cooler
      @openEditFormDialog="openEditFormDialog"
      :dispatchOrderCode="dispatchOrderCode"
    />
    <el-dialog
      :title="dialogOption.title"
      :visible="dialogOption.visible"
      v-if="dialogOption.visible"
      width="1200px"
      :close-on-click-modal="false"
      :before-close="() => (dialogOption.visible = false)"
      append-to-body
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <Icechops
            :disabled="dialogOption.disabled"
            :coolerCode="dialogOption.coolerCode"
            :coolerNo="dialogOption.coolerNo"
            :dispatchOrderCode="dispatchOrderCode"
          />
        </el-col>
        <el-col :span="12">
          <Thermometer
            :disabled="dialogOption.disabled"
            :coolerCode="dialogOption.coolerCode"
            :coolerNo="dialogOption.coolerNo"
            :dispatchOrderCode="dispatchOrderCode"
          />
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="() => (dialogOption.visible = false)">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Cooler from './cooler.vue'
import Icechops from './icechops'
import Thermometer from './thermometer'
export default {
  components: { Cooler, Icechops, Thermometer },
  props: {
    dispatchOrderCode: { type: String, default: '' },
  },
  data() {
    return {
      dialogOption: {
        title: '',
        visible: false,
        coolerCode: '',
        coolerNo: '',
        disabled: false,
      },
    }
  },
  methods: {
    openEditFormDialog({ coolerCode, coolerNo, type = '' }) {
      const types = {
        edit: '编辑冰排/温度计信息',
        detail: '查看冰排/温度计信息',
      }
      this.dialogOption = {
        visible: true,
        title: types[type],
        coolerCode,
        coolerNo,
        disabled: type === 'detail',
      }
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 20px;
}
</style>
